module.exports = __webpack_public_path__ + "img/smile3.0.38e389e4.svg";